import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { find, isEmpty } from 'lodash';
import TemplateList from './TemplateList';
import TemplateColorsList from './TemplateColorsList';
import TemplateFonts from './TemplateFonts';
import GlobalContext from '../../../utils/GlobalContext';
import { PORTFOLIO_VISIBLE_TEMPLATE_SYS_NAMES } from '../../../utils/const';

const ChooseTemplateSection = ({ disabled = false }) => {
  const {
    portfolioTemplate: { collection },
    portfolioStyle: { activeTemplateName, templateSettings },
  } = useSelector((state) => state);

  const activeTemplateSettings = templateSettings
    ? templateSettings[activeTemplateName]
    : {};

  const templates = collection ?? [];

  const activeTemplate = find(templates, ['sysName', activeTemplateName]);

  const templateCollectionForDisplay = useMemo(() => {
    const allowedTemplates = templates.filter((template) =>
      PORTFOLIO_VISIBLE_TEMPLATE_SYS_NAMES.includes(template.sysName),
    );

    return allowedTemplates;
  }, [templates, activeTemplate]);

  const { locales } = useContext(GlobalContext);

  return (
    <div>
      <div className="templates-top-wrapper">
        {locales.portfolio.template.sectionTitle}
      </div>
      <div className="templates-wrapper fullwidth">
        {!isEmpty(templateCollectionForDisplay) &&
          activeTemplateName &&
          activeTemplate && (
            <div className="templates-content">
              <div className="templates-content--left">
                <div className="choose-template-content">
                  <div className="choose-template">
                    {locales.portfolio.template.chooseTemplate}
                  </div>
                </div>
                <div className="templates">
                  <TemplateList
                    templateCollection={templateCollectionForDisplay}
                    activeTemplateName={activeTemplateName}
                    disabled={disabled}
                  />

                  <TemplateColorsList
                    activeTemplate={activeTemplate}
                    templateSettings={templateSettings}
                    customColors={activeTemplateSettings?.customColors}
                    activeColorPalette={activeTemplateSettings?.colorPalette}
                    activeTemplateName={activeTemplateName}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div>
                <div className="choose-template choose-template-media">
                  {locales.portfolio.template.chooseFontStyles}
                </div>
                <TemplateFonts
                  templateSettings={templateSettings}
                  settings={activeTemplateSettings}
                  activeTemplate={activeTemplate}
                  disabled={disabled}
                />
              </div>
            </div>
          )}
      </div>
    </div>
  );
};
export default ChooseTemplateSection;
